/**
 * Mixin can be used to check current url for some parameters (hash, query, etc.)
 *
 * @mixin
 */
export default {
  methods: {
    /**
     * Returns whether the current url has a hash attached or not.
     *
     * @returns {Boolean}
     */
    hasHash() {
      const { hash } = window.location;

      if (!hash) {
        return false;
      }

      return hash !== '';
    },

    /**
     * Returns the hash value from the current url without the '#'.
     *
     * @returns {String} - Returns an empty string if no hash is present, the value otherwise.
     */
    getHashValue() {
      if (!this.hasHash()) {
        return null;
      }

      return window.location.hash.replace('#', '');
    },
  },
};
